import React, { useMemo } from 'react';
import cn from 'classnames';
import { nanoid } from 'nanoid';
import PropTypes from 'prop-types';

import { applyClasses } from '../shared/js';
import styles from './accordion.module.scss';

const AccordionToggle = (props) => {
  const id = useMemo(() => {
    return props.id ? props.id : nanoid();
  }, [props.id]);

  return (
    <>
      <input
        defaultChecked={props.open}
        id={id}
        type={props.group ? 'radio' : 'checkbox'}
        name={props.group}
      />
      <label
        className={cn(
          styles.toggle,
          props.className, // eslint-disable-line react/prop-types
          applyClasses(props, styles)
        )}
        htmlFor={id}
      >
        {props.children}
      </label>
    </>
  );
};

AccordionToggle.propTypes = {
  /** The default state of the accordion */
  open: PropTypes.bool,
  /** A name used to group accordion elements so opening one will close the others */
  group: PropTypes.string,
  /** A unique ID for the accordion  */
  id: PropTypes.string,
  /** Pass children elements to this element */
  children: PropTypes.node,
};

AccordionToggle.defaultProps = {
  open: false,
  group: undefined,
  id: undefined,
  children: undefined,
};

export default AccordionToggle;
